// extracted by mini-css-extract-plugin
export default {"container":"text-table-cell_container__fLQzS"};